<template>
  <!-- <f7-page class="EditAccountMember"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <div class="layoutTop"/>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-10 offset-md-1">
      <div class="panel21 panel-default">
        <form>
          <div class="form-group row">
            <label class="col-5 col-sm-2 col-form-label">{{ $t('loginPage.lgn') }}</label>
            <div class="col-7 col-sm-10">
              <input class="form-control" placeholder="Login" v-model="login" readonly></input>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2 offset-md-9">
      <button round
        class="button-action firstButtonMarginTop"
        :title="$t('common.negot')"
        @click="changeAccountMember">
        <i class="icon fa fa-save"></i>
        <span>Save</span>
      </button>
    </div>
  </div>
</div>
      <div class="toolbarPageBottomBlank"></div>
  <!-- </f7-page> -->
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'EditAccountMember',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      login: '',
      status: ''
    }
  },
  created () {
    this.login = this.$settings.currentAccountMember.login
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    removeAccountMember () {
      let that = this
      that.$f7.confirm('Are you sure to delete this account member?', 'Operation confirmation', function () {
        that.$engine.accounts
        .deleteUserFromAccount(that.$settings.currentAccountMember.id)
        .then(resp => {
          that.$f7.modal({
            title: 'Account deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.login = ''
            that.$f7.closeModal()
            // that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    },
    changeAccountMember () {
      let that = this
      this.$f7.modal({
        title: 'Do you really want to modify user ' + that.login + ' ?',
        buttons: [
          {
            text: 'Cancel',
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: 'Yes',
            onClick: function () {
              that.$f7.showPreloader('')
              if (that.login !== '') {
                that.$engine.accounts.editUserToAccount(that.login)
                  .then(response => {
                    if (response.status === 200) {
                      that.$f7.hidePreloader()
                      that.$f7.closeModal()
                      that.$f7.alert('User modified', 'Success')
                      that.$bus.$emit('refresh-cache-account-members')
                      loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
                    }
                  })
                  .catch(err => {
                    that.$f7.hidePreloader()
                    that.$f7.closeModal()
                    this.handleError(err) // mixins errorHandlerMixins
                  })
              } else {
                that.$f7.hidePreloader()
                that.$f7.alert('', 'Data empty')
              }
            }
          }
        ]
      })
    }
  }
}
</script>
